<template>
  <div>
    <div class="box">
      <div class="title">
        <span class="icon"></span>
        购课信息
      </div>
      <div class="content">
        <div class="subTitle">课程名称</div>
        <div class="textWrapper">{{ detail.productName }}</div>
        <div v-if="jugeFleds(detail)">
          <div v-if="detail.subjectName" class="subTitle">科目</div>
          <div v-if="detail.subjectName" class="textWrapper">{{ detail.subjectName }}</div>
          <div class="subTitle">用于进群的微信名</div>
          <div class="textWrapper">{{ detail.wxUserName }}</div>
          <div class="subTitle">订单截图凭证</div>
      </div>
      </div>
    </div>

    <div class="box">
      <div class="title">
        <span class="icon"></span>
        订单信息
      </div>
      <div class="content">
        <div class="subTitle">下单UID</div>
        <div class="textWrapper">{{ detail.buserId }}</div>
        <div class="subTitle">购买订单号</div>
        <div class="textWrapper">{{ detail.borderNo }}</div>
      </div>
    </div>

    <div class="box">
      <div class="title">
        <span class="icon"></span>
        收货信息
      </div>
      <div class="content">
        <div class="subTitle">姓名</div>
        <div class="textWrapper">{{ detail.consignee }}</div>
        <div class="subTitle">手机号</div>
        <div class="textWrapper">{{ detail.phone }}</div>
        <div class="subTitle">详细地址</div>
        <div class="textWrapper">{{ `${detail.province ?? ''}${detail.city ?? ''}${detail.area ?? ''}${detail.addressDetail}` }}</div>
      </div>
    </div>

    <van-image-preview
      v-model="isShowPreview"
      :images="detail.orderImgList"
      :startPosition="startPosition"
      get-container="body"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowPreview: false,
      startPosition: 0,
    };
  },
  methods: {
    jugeFleds(detail) {
      if (detail.bproductId && Number(detail.bproductId) !== 1418) {
        return true;
      }
      return false;
    },
    previewImage(index) {
      // 图片预览
      this.isShowPreview = true;
      this.startPosition = index;
    },
  },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>
.box {
  margin: 0 36px 22px;
  background: #FFF;
  border-radius: 14px;

  .title {
    padding-top: 33px;
    color: #333;
    font-weight: 500;
    font-size: 33px;

    .icon {
      display: inline-block;
      width: 7px;
      height: 29px;
      margin-right: 29px;
      background: #FF7F41;
    }
  }

  .subTitle {
    margin-top: 29px;
    margin-bottom: 14px;
    font-size: 25px;
  }

  .listImg {
    width: 187px;
    height: 187px;
    ::v-deep .van-image__img {
      border-radius: 14px;
    }
  }

  .textWrapper {
    width: 100%;
    min-height: 54px;
    padding: 11px 0 0 22px;
    color: #666;
    font-size: 22px;
    line-height: 31px;
    background: #F8F9FB;
    border-radius: 4px;
  }

  .content {
    padding: 36px;
  }
}
</style>
